import { rem } from 'polished'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'

import HorizontalContainerWithFadedOverflow from 'components/Common/HorizontalContainerWithFadedOverflow'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'

const StyledGroup = styled(Group)`
  padding: ${rem(4)} ${rem(20)};

  ${mediaQueryUp.tablet} {
    padding: ${rem(4)} ${rem(40)};
  }

  @media print {
    display: none;
  }
`

function FilterChipsScrollContainer({ children }: PropsWithChildren<{}>) {
  return (
    <HorizontalContainerWithFadedOverflow>
      <StyledGroup gap={8} horizontalAlign="start" direction="horizontal">
        {children}
      </StyledGroup>
    </HorizontalContainerWithFadedOverflow>
  )
}

export default FilterChipsScrollContainer
